import {
  IEditData,
  IWarning,
} from 'redux/modules/DiscountEditor/discountEditorTypes';
import { RootState } from '../../store';
import {
  IAboutFormData,
  ICompanyInfoData,
  IMainInfoData,
} from './discountEditorTypes';

export const getAboutFormData = (state: RootState) =>
  state.discountEditor.aboutFormData || ({} as IAboutFormData);

export const getMainInfoData = (state: RootState) =>
  state.discountEditor.mainInfoData || ({} as IMainInfoData);

export const getSelectedCities = (state: RootState) =>
  state.discountEditor.selectedCities;

export const getDiscountCountry = (state: RootState) =>
  state.discountEditor.discountCountry;

export const getCompanyInfoData = (state: RootState) =>
  state.discountEditor.companyInfoData || ({} as ICompanyInfoData);

export const getEditMode = (state: RootState) =>
  state.discountEditor.editMode || ({} as IEditData);

export const getWarning = (state: RootState) =>
  state.discountEditor.warning || ({} as IWarning);
